export const activeTypes = [
  { label: "Activo", value: true, color: "green" },
  { label: "Inactivo", value: false, color: "red" }
];
